export default __webpack_public_path__ + "static/media/stained.43ef6adf.png";